import React from 'react'
import BusinessRules from 'src/app/BusinessRules/BusinessRules'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { businessRulesRouteProps } from 'src/navigation/routeProps'

const BusinessRulesAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsBusinessRules,
  routeProps: businessRulesRouteProps,
  component: <BusinessRules />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default BusinessRulesAppRoute
